import { IAppState, Rechtsstreitigkeiten } from '../../../store/appState';

export const selectRechtsstreitigkeiten = (state: IAppState): Rechtsstreitigkeiten =>
  state.rechtsstreitigkeiten;
export const selectRechtsstreitigkeitenUeberschritten = (state: IAppState): boolean =>
  state.rechtsstreitigkeiten.anzahl > 2;
